<nb-tabset>
    <nb-tab *ngIf="usersRol.CONSULTAR_AVERIAS" tabTitle="Consultas" tabIcon="search-outline" responsive>
        <div class="row">
            <div>
                <nb-select size="tiny" placeholder="Reporte" [(ngModel)]="reporteSelected"
                    (ngModelChange)="cambioReporte($event)">
                    <nb-option *ngFor="let rep of reportes" [value]="rep.Codigo">{{rep.Name}}</nb-option>
                </nb-select>
            </div>
            <div *ngIf="mostrar.buque">
                <nb-select size="tiny" placeholder="Buque" [(ngModel)]="buqueSelected" (ngModelChange)="changeBuque()">
                    <nb-option *ngFor="let buque of buques" [value]="buque.descripcion">{{buque.descripcion}}
                    </nb-option>
                </nb-select>
            </div>

              <div *ngIf="mostrar.procesosvisitas">
                <nb-select size="tiny" placeholder="Visita" [(ngModel)]="visitaSelected" (ngModelChange)="changeBuque()">
                    <nb-option *ngFor="let visita of visitas" [value]="visita">{{visita.descripcion}}
                    </nb-option>
                </nb-select>
            </div>

            <div *ngIf="mostrar.procesosvisitas">
                <nb-select size="tiny" placeholder="Proceso" [(ngModel)]="procesoSelected"
                (ngModelChange)="changeProceso()">
                <nb-option *ngFor="let proc of procesosvisitas" [value]="proc.Codigo">{{proc.Name}}</nb-option>
            </nb-select>
            </div>
            <div *ngIf="mostrar.vin">
                <input type="text" nbInput placeholder="VIN" [(ngModel)]="vinSelected" (ngModelChange)="changeVin()"
                    maxlength="17">
            </div>
            <div *ngIf="mostrar.responsable">
                <nb-select size="tiny" placeholder="Responsable" [(ngModel)]="responsableSelected"
                    (ngModelChange)="changeResponsable()">
                    <nb-option *ngFor="let resp of responsables" [value]="resp.id">{{resp.descripcion}}</nb-option>
                </nb-select>
            </div>
            <div *ngIf="mostrar.proceso">
                <nb-select size="tiny" placeholder="Proceso" [(ngModel)]="procesoSelected"
                    (ngModelChange)="changeProceso()">
                    <nb-option *ngFor="let proc of procesos" [value]="proc.Codigo">{{proc.Name}}</nb-option>
                </nb-select>
            </div>
            <div *ngIf="mostrar.fechas">
                <div class="fechas-container">
                   <mat-form-field   appearance="fill" class="custom-mat-field" style="margin-left: 0px; margin-top: -17px;">
                    <mat-label style="margin-left: 5px;" >Fecha Desde</mat-label>
                    <input style="font-size: 12px;" matInput disabled [matDatepicker]="picker1" name="Desde" [(ngModel)]="fechaDesdeInspec">
                    <mat-datepicker-toggle  matSuffix [for]="picker1">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                </mat-form-field> 
                </div>

            </div>
            <div *ngIf="mostrar.fechas">

                    <mat-form-field style="margin-left: 8px; margin-top: -17px;">
                        <mat-label>Fecha Hasta</mat-label>
                        <input matInput [disabled]="true" [matDatepicker]="picker2" name="Hasta" [(ngModel)]="fechaHastaInspec">
                        <mat-datepicker-toggle matSuffix [for]="picker2">
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker2 disabled="false"></mat-datepicker>
                    </mat-form-field> 
            </div>
            <div style="margin-left: 8px;">
                <button nbButton size="tiny" class=" buttontz" (click)="armarColumnas()"
                    [disabled]="deshabilitarBuscarConsulta">Buscar</button>
            </div>
        </div>
        <div *ngIf="!showContInsp">
            <h4 style="margin-right: 5px; margin-top: 4px; margin-bottom: 0px; font-weight: bolder">
                Averias: {{cantidadAverias}}
                Filtrados: {{filtrado}}
            </h4>
        </div>
        <div *ngIf="showContInsp">
            <h4 style="margin-right: 5px; margin-top: 4px; margin-bottom: 0px; font-weight: bolder">
                Inspecciones: {{cantidadInspecciones}}
                Averias: {{cantidadAverias}}
                Filtrados: {{filtrado}}
            </h4>
        </div>
        <app-spinner *ngIf="showSpinner"></app-spinner>
        <div *ngIf="showGrilla">
             <!-- <angular-slickgrid gridId="gridConsul" [columnDefinitions]="columnDefinitionsConsultas"
                [gridOptions]="gridOptionsConsultas" [dataset]="datasetConsultas" gridHeight="380" gridWidth="100%"
                (onAngularGridCreated)="angularGridReady($event)"
                (sgOnRowCountChanged)="refreshMetrics($event.detail.args)">
            </angular-slickgrid>  -->
             <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetConsultas"
            [columnDefs]="columnDefinitionsConsultas"
            [getRowHeight]="getRowHeight"
            [rowClassRules]="rowClassRules"
           (modelUpdated)="refreshMetrics($event)"
             (gridReady)="onGridReady($event)"
            [enableCellTextSelection]="true"
            
            /> 
        </div>
        <!-- (filterChanged)="onFiltroAplicado($event)" -->
        <div id="popupDetalle" *ngIf="mostrarPopup" class="popup" (click)="cerrarPopup()">
        <div class="popup-content" (click)="$event.stopPropagation()">
            <span class="popup-cerrar" (click)="cerrarPopup()">&times;</span>
            <h3>{{ popupTitulo }}</h3>
            <div [innerHTML]="popupBody"></div>
        </div>
        </div>

        <div *ngIf="showExpo">
            <button nbButton size="tiny" style="float: right; margin-top: 5px;" class=" buttontz"
                [disabled]="deshabilitarExportAverias" (click)="exportToExcelAverias()">
                <nb-icon icon="save-outline"></nb-icon>Exportar
            </button>
        </div>
        <div *ngIf="showRepo"><button nbButton size="tiny" style="float: right; margin-top: 5px;" class="buttontz"
                (click)="openPopUp(optionsReportes)" [disabled]="bloqueoGenerar">Generar Reporte</button></div>
        <div *ngIf="mostrar.vin">
            <button nbButton size="tiny" style="float: right; margin-top: 5px;" class="buttontz"
                (click)="generarReporteSinAverias()" [disabled]="bloqueoSinAverias">Sin Averias</button>
        </div>
    </nb-tab>
    <nb-tab *ngIf="usersRol.GESTIONAR_DISCREPANCIAS" tabTitle="Discrepancias" tabIcon="swap-outline" responsive>
        <div class="row">
            <div style="margin-right: 50px;">
                <!-- <nb-radio-group [(ngModel)]="tipoProcesoSeleccionado">
                    <nb-radio *ngFor="let opcionProceso of opcionesProceso"
                        [checked]="tipoProcesoSeleccionado"
                        [value]="opcionProceso.value"
                        class="radioButton">
                        {{ opcionProceso.label }}
                    </nb-radio>
                </nb-radio-group> -->
                <nb-select size="tiny" placeholder="Proceso" [(ngModel)]="procesoSelected"
                    (ngModelChange)="changeProcesoDiscrepancia()">
                    <nb-option *ngFor="let proc of procesos" [value]="proc.Codigo">{{proc.Name}}</nb-option>
                </nb-select>
            </div>
            <div style="margin-right: 20px;">
                   
            <nb-toggle [checked]="checkActiva" (checkedChange)="checkActiva = $event; changeEstadoActiva()">Activas</nb-toggle>

 <!-- <nb-toggle labelPosition="start" [(ngModel)]="checkActiva" (ngModelChange)="changeEstadoActiva()">
                    Activas</nb-toggle>  -->
            </div>
            <div style="margin-right: 50px;">
                <nb-toggle labelPosition="start" [(ngModel)]="checkSolucionado"
                    (ngModelChange)="changeEstadoSolucionado()">Solucionadas</nb-toggle>
            </div>
            <div style="margin-right: 20px;">
                <mat-form-field>
                    <mat-label>Fecha Desde</mat-label>
                    <input matInput [matDatepicker]="picker3" [disabled]="true" (ngModelChange)="changeDesdeDiscrepancia($event)"
                        [(ngModel)]="DesdeDiscrepancia" name="DesdeDiscrepancia">
                    <mat-datepicker-toggle matSuffix [for]="picker3">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker3 disabled="false"></mat-datepicker>
                </mat-form-field>
            </div>
            <div style="margin-right: 20px;">
                <mat-form-field>
                    <mat-label>Fecha Hasta</mat-label>
                    <input matInput [matDatepicker]="picker4" [disabled]="true" (ngModelChange)="changeHastaDiscrepancia($event)"
                        [(ngModel)]="HastaDiscrepancia" name="HastaDiscrepancia">
                    <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                    <mat-datepicker #picker4 disabled="false"></mat-datepicker>
                </mat-form-field>
            </div>
            <div>
                <button nbButton size="tiny" style="float: right;" class="buttontz" (click)="buscarDiscrepancias()"
                    [disabled]="deshabilitarBuscar">Buscar</button>
            </div>
        </div>
        <h4 style="margin-bottom: 20px; font-weight: bolder;">Activas: {{cantidadActivas}} Solucionadas:
            {{cantidadSolucionadas}}</h4>
        <div>
            <nb-card *ngIf="showCards" class="container"
                style="background-color: transparent; border-color: transparent;">
                <app-spinner></app-spinner>
            </nb-card>
            <nb-card class="container infoCard" *ngFor="let discrepancia of discrepancias">
                <div class="row col-12" style="margin-top: -12px">
                    <div class="d-flex col-3 float left InfoCard" style="margin-left:-40px">
                        <nb-card-body>
                            <strong class="float-left Vin">{{discrepancia.vinAveria.vin}}</strong><br>
                            <span class="FontSmall">Estado: {{discrepancia.estado}}</span><br>
                            <span class="FontSmall">Discrepancia: {{discrepancia.id}}</span>
                        </nb-card-body>
                    </div>
                    <div class="row col-4">
                        <nb-card-body>
                            <span class="FontSmall">Cedente: {{discrepancia.cedente}}</span><br>
                            <p class="Font-xSmall">
                                Área: {{discrepancia.vinAveria.areaComponente}}<br>
                                Tipo: {{discrepancia.vinAveria.tipoAveria}}<br>
                                Fecha: {{discrepancia.vinAveria.fecha | date:"dd/MM/yyyy HH:mm"}}<br>
                                Origen: {{discrepancia.vinAveria.origen}}<br>
                                Clasificación: {{discrepancia.vinAveria.clasificacion}}
                            </p>
                        </nb-card-body>
                    </div>
                    <div class="row col-4">
                        <nb-card-body>
                            <span class="FontSmall">Receptor: {{discrepancia.receptor}}</span><br>
                            <div *ngIf="discrepancia.solucionada">
                                <p class="Font-xSmall">
                                    Área: {{discrepancia.inspeccionVinAveria.areaComponente}}<br>
                                    Tipo: {{discrepancia.inspeccionVinAveria.tipoAveria}}<br>
                                    Fecha: {{discrepancia.inspeccionVinAveria.fecha | date:"dd/MM/yyyy HH:mm"}}<br>
                                    Origen: {{discrepancia.inspeccionVinAveria.origen}}<br>
                                    Clasificación: {{discrepancia.inspeccionVinAveria.clasificacion}}
                                </p>
                            </div>
                            <div *ngIf="!discrepancia.solucionada">
                                <p class="Font-xSmall">
                                    Comentario: {{discrepancia.comentario}}
                                </p>
                            </div>
                        </nb-card-body>
                    </div>
                    <div class="row col-1 float-right" style="margin-left: 110px;">
                        <button nbButton (click)="open(discrepancia.solucionada, discrepancia.id)" size="medium" ghost
                            class="btn-detalles" style="background-color: transparent;">
                            <nb-icon icon="maximize-outline"></nb-icon>
                        </button>
                    </div>
                </div>
            </nb-card>
        </div>

    </nb-tab>
</nb-tabset>

<ng-template #optionsReportes>
    <div style="height: 50px;">
        <app-options-reportes (cerrar)="hideReport($event)" [data]="filtrosReportes" [idTipoOperador]="idTipoOperador" [usarCheckbox]="usarCheckbox">
        </app-options-reportes>
    </div>
</ng-template>